import { observer } from 'mobx-react-lite'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useWorkspace } from 'hooks/useWorkspace'
import { isHelpCenterWorkspace } from 'utils/workspaceUtils'
import { NotificationsTray } from './NotificationsTray'
import { UserRole } from 'types'
import { ReactNode } from 'react'
import { CounterVariant } from 'blaze-ui/Counter/Counter'

export interface Props {
  trigger?: ReactNode
  counterVariant?: CounterVariant
}

export const NotificationsTrayContainer = observer((props: Props) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const currentWorkspace = useWorkspace(currentWorkspaceId)
  const isHelpCenter = isHelpCenterWorkspace(currentWorkspaceId)
  const isGuest =
    currentWorkspace?.guest || currentWorkspace?.role === UserRole.GUEST || currentWorkspace?.role === UserRole.UNAUTHED

  if (isHelpCenter || isGuest) return null

  return <NotificationsTray {...props} />
})
